import { Component } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { AboutBelieveSection } from '../../../components/about/about-believe-section/about-believe-section';
import { AboutPackingSection } from '../../../components/about/about-packing-section/about-packing-section';
import { AboutTeamSection } from '../../../components/about/about-team-section/about-team-section';
import { AboutUsSection } from '../../../components/about/about-us-section/about-us-section';
import { TitleService } from '../../../services/title.service';

@Component({
  selector: 'app-about-us-page',
  imports: [
    MatDividerModule,
    AboutUsSection,
    AboutPackingSection,
    AboutTeamSection,
    AboutBelieveSection,
  ],
  templateUrl: './about-us-page.html',
  styleUrl: './about-us-page.scss',
})
export class AboutUsPage {
  constructor(private titleService: TitleService) {
    this.titleService.setTitle('About Us');
  }
}
